export const galleryImages = [
  // Food
  {
    id: 1,
    src: 'https://images.unsplash.com/photo-1574071318508-1cdbab80d002?w=800&h=600&fit=crop',
    alt: {
      de: 'Pizza Margherita aus dem Steinofen',
      en: 'Stone oven Pizza Margherita'
    },
    category: 'food'
  },
  {
    id: 2,
    src: 'https://images.unsplash.com/photo-1612874742237-6526221588e3?w=800&h=600&fit=crop',
    alt: {
      de: 'Spaghetti Carbonara',
      en: 'Spaghetti Carbonara'
    },
    category: 'food'
  },
  {
    id: 3,
    src: 'https://images.unsplash.com/photo-1571877227200-a0d98ea607e9?w=800&h=600&fit=crop',
    alt: {
      de: 'Hausgemachtes Tiramisu',
      en: 'Homemade Tiramisu'
    },
    category: 'food'
  },
  {
    id: 4,
    src: 'https://images.unsplash.com/photo-1608897013039-887f21d8c804?w=800&h=600&fit=crop',
    alt: {
      de: 'Burrata mit Tomaten',
      en: 'Burrata with Tomatoes'
    },
    category: 'food'
  },
  {
    id: 5,
    src: 'https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?w=800&h=600&fit=crop',
    alt: {
      de: 'Pizza Prosciutto e Rucola',
      en: 'Prosciutto and Arugula Pizza'
    },
    category: 'food'
  },
  {
    id: 6,
    src: 'https://images.unsplash.com/photo-1544025162-d76694265947?w=800&h=600&fit=crop',
    alt: {
      de: 'Ossobuco alla Milanese',
      en: 'Ossobuco Milanese'
    },
    category: 'food'
  },

  // Interior
  {
    id: 10,
    src: 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=800&h=600&fit=crop',
    alt: {
      de: 'Eleganter Speisesaal',
      en: 'Elegant dining room'
    },
    category: 'interior'
  },
  {
    id: 11,
    src: 'https://images.unsplash.com/photo-1559329007-40df8a9345d8?w=800&h=600&fit=crop',
    alt: {
      de: 'Gemütliche Ecke',
      en: 'Cozy corner'
    },
    category: 'interior'
  },
  {
    id: 12,
    src: 'https://images.unsplash.com/photo-1552566626-52f8b828add9?w=800&h=600&fit=crop',
    alt: {
      de: 'Einladende Bar',
      en: 'Inviting bar'
    },
    category: 'interior'
  },
  {
    id: 13,
    src: 'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=800&h=600&fit=crop',
    alt: {
      de: 'Gedeckte Tafel',
      en: 'Set table'
    },
    category: 'interior'
  },
  {
    id: 14,
    src: 'https://images.unsplash.com/photo-1466978913421-dad2ebd01d17?w=800&h=600&fit=crop',
    alt: {
      de: 'Außenterrasse',
      en: 'Outdoor terrace'
    },
    category: 'interior'
  },

  // Events
  {
    id: 20,
    src: 'https://images.unsplash.com/photo-1530103862676-de8c9debad1d?w=800&h=600&fit=crop',
    alt: {
      de: 'Hochzeitsfeier',
      en: 'Wedding celebration'
    },
    category: 'events'
  },
  {
    id: 21,
    src: 'https://images.unsplash.com/photo-1511795409834-ef04bbd61622?w=800&h=600&fit=crop',
    alt: {
      de: 'Firmenveranstaltung',
      en: 'Corporate event'
    },
    category: 'events'
  },
  {
    id: 22,
    src: 'https://images.unsplash.com/photo-1529543544277-c91c78c3bbcd?w=800&h=600&fit=crop',
    alt: {
      de: 'Weinverkostung',
      en: 'Wine tasting'
    },
    category: 'events'
  },
  {
    id: 23,
    src: 'https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=800&h=600&fit=crop',
    alt: {
      de: 'Kochkurs',
      en: 'Cooking class'
    },
    category: 'events'
  },

  // Team
  {
    id: 30,
    src: 'https://images.unsplash.com/photo-1577219491135-ce391730fb2c?w=800&h=600&fit=crop',
    alt: {
      de: 'Unser Küchenchef bei der Arbeit',
      en: 'Our head chef at work'
    },
    category: 'team'
  },
  {
    id: 31,
    src: 'https://images.unsplash.com/photo-1581299894007-aaa50297cf16?w=800&h=600&fit=crop',
    alt: {
      de: 'Service-Team',
      en: 'Service team'
    },
    category: 'team'
  },
  {
    id: 32,
    src: 'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=800&h=600&fit=crop',
    alt: {
      de: 'Pizzabäcker am Steinofen',
      en: 'Pizza chef at stone oven'
    },
    category: 'team'
  }
];

export const getImagesByCategory = (category) => {
  if (category === 'all') return galleryImages;
  return galleryImages.filter(img => img.category === category);
};

export const galleryCategories = [
  { id: 'all', label: { de: 'Alle', en: 'All' } },
  { id: 'food', label: { de: 'Gerichte', en: 'Dishes' } },
  { id: 'interior', label: { de: 'Ambiente', en: 'Interior' } },
  { id: 'events', label: { de: 'Events', en: 'Events' } },
  { id: 'team', label: { de: 'Team', en: 'Team' } }
];
